export const customerConstants = {
    CUSTOMER_GET_LIST_REQUEST: 'CUSTOMER_GET_LIST_REQUEST',
    CUSTOMER_GET_LIST_SUCCESS: 'CUSTOMER_GET_LIST_SUCCESS',
    CUSTOMER_GET_LIST_FAILURE: 'CUSTOMER_GET_LIST_FAILURE',

    ASSIGN_CUSTOMER_GET_LIST_REQUEST: 'ASSIGN_CUSTOMER_GET_LIST_REQUEST',
    ASSIGN_CUSTOMER_GET_LIST_SUCCESS: 'ASSIGN_CUSTOMER_GET_LIST_SUCCESS',
    ASSIGN_CUSTOMER_GET_LIST_FAILURE: 'ASSIGN_CUSTOMER_GET_LIST_FAILURE',

    GET_ALL_CUSTOMER_REQUEST: 'GET_ALL_CUSTOMER_REQUEST',
    GET_ALL_CUSTOMER_SUCCESS: 'GET_ALL_CUSTOMER_SUCCESS',
    GET_ALL_CUSTOMER_FAILURE: 'GET_ALL_CUSTOMER_FAILURE',

    CUSTOMER_ANALYTICS_COUNT_REQUEST: 'CUSTOMER_ANALYTICS_COUNT_REQUEST',
    CUSTOMER_ANALYTICS_COUNT_SUCCESS: 'CUSTOMER_ANALYTICS_COUNT_SUCCESS',
    CUSTOMER_ANALYTICS_COUNT_FAILURE: 'CUSTOMER_ANALYTICS_COUNT_FAILURE',

    SAVE_CUSTOMER_REQUEST: 'SAVE_CUSTOMER_REQUEST',
    SAVE_CUSTOMER_SUCCESS: 'SAVE_CUSTOMER_SUCCESS',
    SAVE_CUSTOMER_FAILURE: 'SAVE_CUSTOMER_FAILURE',

    UPDATE_CUSTOMER_REQUEST: 'UPDATE_CUSTOMER_REQUEST',
    UPDATE_CUSTOMER_SUCCESS: 'UPDATE_CUSTOMER_SUCCESS',
    UPDATE_CUSTOMER_FAILURE: 'UPDATE_CUSTOMER_FAILURE',

    CUSTOMER_BLOCK_REQUEST: 'CUSTOMER_BLOCK_REQUEST',
    CUSTOMER_BLOCK_SUCCESS: 'CUSTOMER_BLOCK_SUCCESS',
    CUSTOMER_BLOCK_FAILURE: 'CUSTOMER_BLOCK_FAILURE',

    CUSTOMER_SOFT_DELETE_REQUEST: 'CUSTOMER_SOFT_DELETE_REQUEST',
    CUSTOMER_SOFT_DELETE_SUCCESS: 'CUSTOMER_SOFT_DELETE_SUCCESS',
    CUSTOMER_SOFT_DELETE_FAILURE: 'CUSTOMER_SOFT_DELETE_FAILURE',



    GET_GRAPH_LIST_REQUEST: "GET_GRAPH_LIST_REQUEST",
    GET_GRAPH_LIST_SUCCESS: "GET_GRAPH_LIST_SUCCESS",
    GET_GRAPH_LIST_FAILURE: "GET_GRAPH_LIST_FAILURE",




}